import common from '../common';
import { translate } from '../utils/index';
import Scene from './Scene';

export default class SplashScene extends Scene {
    constructor() {
        super();

    }

    init() {
        super.init();

        this._bg = new PIXI.Sprite(P3.assets.texture('bg_main'));
        // bg.anchor.set(0.5);
        //  bg.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this._bg.width = common.STAGE_WIDTH;
        this._bg.height = common.STAGE_HEIGHT;
        this.addChild(this._bg);

        let states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_primary_small_out');
        states.over = P3.assets.texture('btn_primary_small_over');
        states.down = P3.assets.texture('btn_primary_small_down');
        states.icon = P3.assets.texture('icon_sound_on');
        states.iconAlt = P3.assets.texture('icon_sound_off');

        this._muteButton = new P3.MuteButton(states);
        this._muteButton.signals.up.add(function () {
            common.saveData.data.mute = !P3.audio.isMuted();
            common.saveData.save();
        }, this);
        this.addChild(this._muteButton);

        this._gameImage = new PIXI.Sprite(P3.assets.texture("game_image"));
        this._gameImage.position.set(common.STAGE_WIDTH/2, common.STAGE_HEIGHT/2);
        this._gameImage.anchor.set(0.5);
        this.addChild(this._gameImage);

        states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_primary_large_out');
        states.over = P3.assets.texture('btn_primary_large_over');
        states.down = P3.assets.texture('btn_primary_large_down');
        states.icon = P3.assets.texture('icon_play');

        this._playButton = new P3.Button(states);
        this._playButton.signals.click.add(this.onPlayButtonClick, this);
        this.addChild(this._playButton);

		this._logo = new PIXI.Sprite(P3.assets.texture("game_logo"));
        this._logo.anchor.set(0.5);
        this.addChild(this._logo);

        this._labelPanelA = new PIXI.Sprite(P3.assets.texture("title_1_bg"));
        this._labelPanelA.anchor.set(0.5);
        this.addChild(this._labelPanelA);

        this._labelPanelB = new PIXI.Sprite(P3.assets.texture("title_1_bg"));
        this._labelPanelB.anchor.set(0.5);
        this._labelPanelB.width = 280;
        //this.addChild(this._labelPanelB);

        this._labelA = new PIXI.Text(translate("how_to"), {
            fontFamily: "Fred Fredburger",
            fontSize: 58,
            dropShadow: true,
            dropShadowAngle: 2.5,
            dropShadowColor: "#fe2e8b",
            fill: "#ffffff",
            padding: 5
        });
        this._labelA.anchor.set(0.5);
        this.addChild(this._labelA);

        this._labelB = new PIXI.Text(translate("show_title"), {
            fontFamily: 'Fred Fredburger',
            fontSize: 58,
            dropShadow: true,
            dropShadowAngle: 2.5,
            dropShadowColor: "#fe2e8b",
            fill: "#fed917",
            padding: 5
        });
        //Add a '!' at the end for portugese language
        //console.log(common.config.language);
        //if (common.config.language === "pt")
        ///this._labelB.text += "!";
        this._labelB.anchor.set(0.5);
        //this.addChild(this._labelB);

        this._pencil = new PIXI.Sprite(P3.assets.texture("pencil"));
        this._pencil.anchor.set(0.5);
        this.addChild(this._pencil);

        //this._head = new PIXI.Sprite(P3.assets.texture("head"));
        //this._head.anchor.set(0.5);
        //this.addChild(this._head);

        //Tweens for menu elements
        //this._head.scale.set(0.9);
        /*new P3.utils.TWEEN.Tween(this._head.scale, this._tweens)
            .to({x: 1.05, y: 1.05}, 940)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .yoyo(true)
            .repeat(Infinity)
            .start();*/

        this._pencil.rotation = -0.8;

        new P3.utils.TWEEN.Tween(this._pencil, this._tweens)
            .to({rotation: -0.6}, 940)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .delay(180)
            .yoyo(true)
            .repeat(Infinity)
            .start();
    }

    destroy() {
        super.destroy();
    }

    resize() {
        super.resize();

        this._muteButton.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 100, 100);
        this._playButton.position.set(common.STAGE_WIDTH * 0.5 + 295, common.STAGE_HEIGHT - 159);

        this._logo.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 + 235);

        this._labelPanelA.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 - 275);
        this._labelPanelA.rotation = -0.05;
        this._labelPanelB.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 + 275);

        this._labelA.position = this._labelPanelA.position.clone();
        this._labelA.rotation = this._labelPanelA.rotation;
        this._labelB.position = this._labelPanelB.position.clone();

        this._labelPanelA.width = this._labelA.width + 60;
        this._labelPanelB.width = this._labelB.width + 50;

        this._pencil.position.set(common.STAGE_WIDTH * 0.5 - 320, common.STAGE_HEIGHT - 200);
        //this._head.position.set(common.STAGE_WIDTH * 0.5 + 320, common.STAGE_HEIGHT - 200);

    }

    animateIn() {
        super.animateIn();
    }

    update() {
        super.update();
    }

    onPlayButtonClick() {
        this.signals.next.dispatch(this);
    }
}
